export const type = {
  USER: 'USER',
  HELP_MENU: 'HELP_MENU',
  BACK: 'BACK',
  TITLE: 'TITLE',
  SEARCH: 'SEARCH',
  QUICK_FILTER: 'QUICK_FILTER',
  SORT_FILTER: 'SORT_FILTER',
  COMPONENT: 'COMPONENT',
  BLANK: 'BLANK'
}

export const boxSides = {
  LEFT: 'right',
  RIGHT: 'left'
}

export const SORT_BY = 'app/TopBarMobile/SORT_BY'
export const FILTER_BY = 'app/TopBarMobile/FILTER_BY'
export const HIDE_ALL = 'app/TopBarMobile/HIDE_ALL'
